import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { MODO_ESCOLHA, MODO_TODAS, emEscolha } from './escolha';

export const TITULO_DO_MODO = 'Fotos da galeria';
export const OPCOES_DO_MODO = [
  [MODO_TODAS, 'Todas as imagens desta página'],
  [MODO_ESCOLHA, 'Escolher as fotos e escrever as legendas'],
];

// O modo fica fora do esquema do formulário. O campo de opções do Volto
// (radio_group) não liga o rótulo a cada opção, e o leitor de tela anunciaria
// "botão de opção" sem nome; aqui são rádios nativos num fieldset. Fora do
// esquema, o formulário também não grava um valor padrão ao abrir a barra.
const ModoDaGaleria = ({ data, block, onChangeBlock }) => {
  const nome = useId();
  const atual = emEscolha(data) ? MODO_ESCOLHA : MODO_TODAS;
  return (
    <div className="ui attached segment ag-galeria-modo">
      <fieldset className="ag-galeria-modo__grupo">
        <legend className="ag-galeria-modo__titulo">{TITULO_DO_MODO}</legend>
        {OPCOES_DO_MODO.map(([valor, rotulo]) => (
          <label key={valor} className="ag-galeria-modo__opcao">
            <input
              type="radio"
              className="ag-galeria-modo__radio"
              name={nome}
              value={valor}
              checked={atual === valor}
              onChange={() => onChangeBlock(block, { ...data, modo: valor })}
            />
            <span>{rotulo}</span>
          </label>
        ))}
      </fieldset>
    </div>
  );
};

ModoDaGaleria.propTypes = {
  data: PropTypes.object.isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default ModoDaGaleria;
